export default __webpack_public_path__ + "static/media/ratemy2.de7d890b.png";